import { render, staticRenderFns } from "./GridPagerCpt.vue?vue&type=template&id=16c59814&scoped=true&"
import script from "./GridPagerCpt.vue?vue&type=script&lang=ts&"
export * from "./GridPagerCpt.vue?vue&type=script&lang=ts&"
import style0 from "./GridPagerCpt.vue?vue&type=style&index=0&id=16c59814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c59814",
  null
  
)

export default component.exports